// extracted by mini-css-extract-plugin
export default {"Layout":"DdcAer8O","container":"Ce8Wn_C1","content":"E9CjVMnO","main":"del6XGck"};
    if(module.hot) {
      // 1764331279839
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  